(function () {
    'use strict';

    angular
        .module('app.shared')
        .filter('handicap', handicapFilter);

    function handicapFilter() {
        return function (value) {
            if (value == null) 
                return null;
            value = parseFloat(value);
            return !isNaN(value) && isFinite(value) ? (value < 0 ? '+' : '') + Math.abs(value).toFixed(1) : 'NH';
        }
    }
})();